import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Button, Text } from '@library';

const FilterShowMore = ({
    showFullList,
    setShowFullList,
    remainingItems,
}: {
    showFullList: boolean;
    setShowFullList: React.Dispatch<React.SetStateAction<boolean>>;
    remainingItems: number;
}) => {
    const intl = useIntl();

    if (showFullList) {
        return (
            <Button
                text
                inline
                secondary
                onClick={() => setShowFullList(false)}
            >
                <Text secondary>{intl.formatMessage({ id: 'show less' })}</Text>
            </Button>
        );
    }

    return (
        <Button text inline secondary onClick={() => setShowFullList(true)}>
            <Text secondary>
                {intl.formatMessage({ id: 'show more' })} ({remainingItems})
            </Text>
        </Button>
    );
};

export default memo(FilterShowMore);
